import React from 'react';
import './GalleryHeader.css'; // import the CSS

const GalleryHeader = () => {
  return (
    <div className="gallery-header">
      <h2 className="gallery-title">Gallery</h2>
      <p className="gallery-subtitle">Check out the latest photos.</p>

      <div className="gallery-actions">
        <button className="quote-button">GET A FAST QUOTE</button>

        <div className="contact-info">
          <div className="phone-icon">📞</div>
          <div className="contact-text">
            <small className="help-text">Get Professional Help</small><br />
            <strong className="phone-number">+91-8951509309</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryHeader;
